import type { Common } from '@/api'
import { createSimpleStore } from '~/utils/pinia/light-simple-store'

type Coin = Common.Settings['coins'][number]
type Warning = Common.State['warning']

interface ExtraData {
  timeSync?: boolean
  webview?: boolean
  warning?: Warning
}

const CoinCodeIconMatcher: Record<string, string> = {
  liga: 'liga'
}

export const useSettingsStore = createSimpleStore(
  'settings',
  {
    getRequests: async () => {
      const { $sdk } = useNuxtApp()
      const { getSettings } = await $sdk.module('common')

      return { get: getSettings }
    }
  },
  context => {
    const extraData = ref<ExtraData>({})

    const getCoinCode = (id?: Coin['id']) =>
      context.data.value?.coins.find(coin => coin.id === id)?.code

    const getCoinIdByCode = (code: Coin['code']) =>
      context.data.value?.coins.find(coin => coin.code === code)?.id

    const getCoinIconByCode = (code?: Coin['code']) => {
      if (code && CoinCodeIconMatcher[code]) {
        return CoinCodeIconMatcher[code]
      }

      return 'unknown-coin'
    }

    const getCoinIconById = (id?: Coin['id']) => {
      const code = getCoinCode(id)

      return getCoinIconByCode(code)
    }

    const fetchState = async (): Promise<Common.State> => {
      const { $sdk } = useNuxtApp()

      const state = await $sdk
        .module('common')
        .then(({ getState }) => getState())

      extraData.value.timeSync = true
      extraData.value.warning = state.warning

      if (context.data.value) {
        context.data.value.time = state.time
      }

      return state
    }

    const setWebview = (isWebview: boolean) => {
      extraData.value.webview = isWebview
    }

    return {
      extraData,
      getCoinCode,
      getCoinIdByCode,
      getCoinIconByCode,
      getCoinIconById,
      fetchState,
      setWebview
    }
  }
)
